<template>
  <blockquote class="sanitas-magazine-quote">
    <div class="sanitas-magazine-quote-title">
      {{ $t('quoteStart') }}<slot></slot>{{ $t('quoteEnd') }}
    </div>
    <div v-if="$slots.author" class="sanitas-magazine-quote-author">
      <slot name="author"></slot>
    </div>
  </blockquote>
</template>

<script>
import { provideI36n, useI36n } from '@jota-one/i36n/src/index.vue2'

export default {
  name: 'SanitasMagazineQuote',
  setup() {
    const language = window.Sanitas.language || 'de'
    const loadLabels = lang => import(`../i18n/${lang}.json`)
    provideI36n(language, { load: loadLabels })
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },
}
</script>

<style lang="postcss">
.sanitas-magazine-quote {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Faustina', serif;
  text-align: center;
  margin-bottom: 40px;

  sup {
    top: -0.2em !important;
  }

  &:before {
    margin-bottom: 40px;
  }

  &:after {
    margin-top: 40px;
  }

  &:after,
  &:before {
    content: '';
    width: 160px;
    height: 1px;
    border: solid 1px var(--c-primary-neutral-1);
  }

  &-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.46;
    letter-spacing: 0.4px;
    color: var(--c-primary-neutral-1);
    width: 80%;
  }

  &-author {
    width: 100%;
    margin-top: 15px;
    font-size: 12px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--c-primary-neutral-1);
  }
}

@media (--xs) {
  .sanitas-magazine-quote-title {
    font-size: 24px;
  }
}
</style>
